import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";

export const getProfileComplete = async () => {
    const res = await api.get("/Clinician/Completion");

    return res.data;
};

export const useProfileComplete = () => {
    return useQuery({
        queryKey: ["profilecomplete"],
        queryFn: getProfileComplete,
        retry: 3,
        staleTime: 1000 * 60,
    });
};
